import React from 'react'

const SettingTenantDealerContainer = () => {
    return (
        <section className="LeadContainer">
        </section>
    )
}

export default SettingTenantDealerContainer